/*@ngInject*/
const OrganizationActionMediator = function (organizationActionRepository) {

    this.deactivateOrganization = function (organizationId, propagateStatusToChildren) {
        return organizationActionRepository.deactivateOrganization(organizationId, propagateStatusToChildren);
    };

    this.activateOrganization = function (organizationId, propagateStatusToChildren) {
        return organizationActionRepository.activateOrganization(organizationId, propagateStatusToChildren);
    };

    this.deleteOrganization = function (organizationId) {
        return organizationActionRepository.deleteOrganization(organizationId);
    };

    this.getFormSetId = function (organizationId) {
        return organizationActionRepository.getFormSetId(organizationId);
    };

    this.updateEmailSignatureById = function (organizationId, emailSignature) {
        return organizationActionRepository.updateEmailSignatureById(organizationId, emailSignature);
    };
};

angular.module('ums.configuration')
    .service('organizationActionMediator', OrganizationActionMediator);
